import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "js-cookie";
import { RetryOnError, verifyToken } from "../utilities/VerifyToken";
import { checkForAuthorization } from "utilities/index";

export const FetchAllInvestorList = () => {
  return useMutation(
    ({ payload, startup_id }) => {
      // console.log("Payload:", payload);
      // console.log("Startup ID:", startup_id);
      return axios({
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/startups/getAllInvestorList/${startup_id}`,
        headers: {
          'Authorization': `Bearer ${checkForAuthorization()}`,
          'Content-Type': 'application/json'
        },
        data: payload
      })
    }, {
    // onSuccess: (data)=>console.log("API successfull"),
    // retry: (failureCount, error)=>{
    //   return RetryOnError(failureCount, error)
    // },
    retry: 0,
    onError: (err) => {
      return verifyToken(err)
    },
  })
}

export const FetchUniqueLocationsList = () => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-listing-isLoadingLocationList-/settings?config_type=FetchUniqueLocationsList'],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/startups/investor-unique-locations-list`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data.data.data[0]?.config_values, "data.data.data[0]")
            return data.data.data
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchStartupMoveShortlistToPipelineList = () => {
  return useMutation(
    ({ payload, startup_id }) => {
      // console.log("Payload:", payload);
      // console.log("Startup ID:", startup_id);
      return axios({
        method: 'put',
        url: `${process.env.REACT_APP_BASE_URL}/startups/moveToPipeline/${startup_id}`,
        headers: {
          'Authorization': `Bearer ${checkForAuthorization()}`,
          'Content-Type': 'application/json'
        },
        data: payload
      })
    }, {
    // onSuccess: (data)=>console.log("API successfull"),
    // retry: (failureCount, error)=>{
    //   return RetryOnError(failureCount, error)
    // },
    retry: 0,
    onError: (err) => {
      return verifyToken(err)
    },
  })
}
export const FetchAllShortlistedInvestorList = () => {
  return useMutation(
    ({ payload, startup_id }) => {
      // console.log("Payload:", payload);
      // console.log("Startup ID:", startup_id);
      return axios({
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/startups/getShortlistInvestor/${startup_id}`,
        headers: {
          'Authorization': `Bearer ${checkForAuthorization()}`,
          'Content-Type': 'application/json'
        },
        data: payload
      })
    }, {
    // onSuccess: (data)=>console.log("API successfull"),
    // retry: (failureCount, error)=>{
    //   return RetryOnError(failureCount, error)
    // },
    retry: 0,
    onError: (err) => {
      return verifyToken(err)
    },
  })
}
export const FetchMoveShortlistedList = () => {
  return useMutation(
    ({ payload, startup_id }) => {
      // console.log("Payload:", payload);
      // console.log("Startup ID:", startup_id);
      return axios({
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/startups/InvestorMoveShortlist/${startup_id}`,
        headers: {
          'Authorization': `Bearer ${checkForAuthorization()}`,
          'Content-Type': 'application/json'
        },
        data: payload
      })
    }, {
    // onSuccess: (data)=>console.log("API successfull"),
    // retry: (failureCount, error)=>{
    //   return RetryOnError(failureCount, error)
    // },
    retry: 0,
    onError: (err) => {
      return verifyToken(err)
    },
  })
}

export const CheckAlreadyExistInPipeline = () => {
  return useMutation(
    ({ payload }) => {
      // console.log("Payload:", payload);
      // console.log("Startup ID:", startup_id);
      return axios({
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/startups/check-pipeline-exists`,
        headers: {
          'Authorization': `Bearer ${checkForAuthorization()}`,
          'Content-Type': 'application/json'
        },
        data: payload
      })
    }, {
    // onSuccess: (data)=>console.log("API successfull"),
    // retry: (failureCount, error)=>{
    //   return RetryOnError(failureCount, error)
    // },
    retry: 0,
    onError: (err) => {
      return verifyToken(err)
    },
  })
}

export const FetchAllInvestorListFromPipeline = () => {
  return useMutation(
    ({ payload, startup_id }) => {
      // console.log("Payload:", payload);
      // console.log("Startup ID:", startup_id);
      return axios({
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/startups/getPipelineInvestor/${startup_id}`,
        headers: {
          'Authorization': `Bearer ${checkForAuthorization()}`,
          'Content-Type': 'application/json'
        },
        data: payload
      })
    }, {
    // onSuccess: (data)=>console.log("API successfull"),
    // retry: (failureCount, error)=>{
    //   return RetryOnError(failureCount, error)
    // },
    retry: 0,
    onError: (err) => {
      return verifyToken(err)
    },
  })
}